function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 89.5,
  cy: 92.5,
  rx: 81.5,
  ry: 83.5,
  fill: "#67B360"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 82.9551,
  width: 75.6357,
  height: 115.54,
  fill: "#ED3E3E"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 101.661,
  y: 21.2389,
  width: 36.5979,
  height: 21.2389,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 99.6833,
  height: 16.6509,
  transform: "matrix(0.709737 -0.704466 0.672891 0.739742 113.047 100.808)",
  fill: "#004122"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 100.414,
  height: 16.5284,
  transform: "matrix(-0.580787 -0.814055 0.789074 -0.614298 58.3193 113.135)",
  fill: "#004122"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 57.7432,
  y: 99.3982,
  width: 64.2496,
  height: 92.6018,
  fill: "#004122"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M50.4238 27.6373L94.2628 11.8939L112 59.0001L83.7686 66.6903L116 74.5001L117.5 88.0001L75.2783 103.157L50.4238 27.6373Z",
  fill: "#004122"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 9.81525,
  height: 19.4369,
  transform: "matrix(0.929678 -0.368373 0.341319 0.939948 135.005 122.554)",
  fill: "#ED3E3E"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 9.75977,
  height: 19.5392,
  transform: "matrix(0.999592 0.0285662 -0.0261808 0.999657 125.758 121.487)",
  fill: "#ED3E3E"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  width: 4.61026,
  height: 15.3536,
  transform: "matrix(-0.12957 -0.99157 0.989987 -0.141159 161.283 155.937)",
  fill: "#ED3E3E"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  width: 4.5054,
  height: 15.7247,
  transform: "matrix(0.730765 -0.682629 0.650321 0.75966 135.005 161.093)",
  fill: "#ED3E3E"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  width: 3.16245,
  height: 11.7156,
  transform: "matrix(-0.656317 -0.754486 0.725287 -0.688447 180.186 151.641)",
  fill: "#ED3E3E"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  width: 3.19888,
  height: 11.5779,
  transform: "matrix(0.415454 -0.909614 0.895005 0.446056 148.272 174.859)",
  fill: "#ED3E3E"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  width: 6.37005,
  height: 15.198,
  transform: "matrix(0.62195 -0.783057 0.755683 0.654937 145.578 144.316)",
  fill: "#ED3E3E"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  width: 6.2425,
  height: 15.5012,
  transform: "matrix(0.924942 -0.380108 0.352446 0.935832 126.873 144.249)",
  fill: "#ED3E3E"
});

function SvgKlemen6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 192,
    viewBox: "0 0 195 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlemen6);
export default __webpack_public_path__ + "static/media/klemen_6.c4d9f6cc.svg";
export { ForwardRef as ReactComponent };